import _ from 'lodash';
import getQueryExpression from './getQueryExpression.js';

export default function getMongoDbQuery(criteria, options = {}) {
  const expressions = _.castArray(criteria || {}).map(c => {
    const exp = getQueryExpression(c, options);
    if (options.useMongoDbId) {
      return _.mapKeys(exp, replaceIdByMongoDbId);
    }
    return exp;
  });
  return expressions.length > 1 ? { $or: expressions } : expressions[0];
}

function replaceIdByMongoDbId(value, key) {
  return key === 'id' ? '_id' : key;
}
